import React, { useEffect, useState } from 'react'
import { Search as SearchIcon } from 'react-feather'
import PropTypes from 'prop-types'
import {
  Box,
  CircularProgress,
  InputAdornment,
  TextField,
} from '@material-ui/core'

import { DocumentTemplatesTable, FolderTable } from './components'

import useSearch from 'hooks/useSearch'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import theme from 'theme'

const DocumentTemplates = ({ filter, folderId, onFolderLoad = () => {} }) => {
  const [wasResetFilters, setWasResetFilters] = useState(false)

  const { response, isLoadingStart } = useFetch(
    service.dponet.documentTemplates.get,
    {
      perPage: 1000,
      ...filter.filters,
      ...(folderId ? { folderId } : { availableDocuments: true }),
    },
    [filter.filters, wasResetFilters, folderId],
    !!wasResetFilters,
  )

  const templates = response?.data?.documentTemplates

  const { response: foldersResponse, isLoadingStart: foldersIsLoadingStart } =
    useFetch(
      service.dponet.documentTemplates.getFolders,
      {
        minimal: true,
        ...(!!folderId ? { folderId } : { perPage: 1000 }),
      },
      [],
      !!wasResetFilters,
    )

  const folder = foldersResponse?.data?.folder
  const folders = foldersResponse?.data?.folders || []

  const { searchInput, handleSearchValue, isSearching } = useSearch((value) => {
    const newFilters = { ...filter.filters }
    if (value) {
      newFilters.nameOrCategory = value
    } else {
      delete newFilters.nameOrCategory
    }
    filter.setFilters(newFilters)
  })

  const filteredTemplates = templates?.filter((template) => {
    if (!searchInput) return true
    const search = searchInput.toLowerCase()
    return (
      template?.name?.toLowerCase().includes(search) ||
      template?.documentCategory?.name?.toLowerCase().includes(search)
    )
  })

  const resetFilters = async (filters = {}) => await filter.setFilters(filters)

  useEffect(() => {
    if (folder) onFolderLoad(folder)
  }, [folder]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    resetFilters({})
    setWasResetFilters(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(1)}>
      <TextField
        fullWidth
        placeholder="Buscar por nome ou categoria"
        value={searchInput}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon size={20} />
            </InputAdornment>
          ),
          endAdornment: isSearching && (
            <InputAdornment position="end">
              <CircularProgress size={20} />
            </InputAdornment>
          ),
        }}
        variant="outlined"
        onChange={handleSearchValue}
      />
      {!folderId && (
        <FolderTable folders={folders} isLoading={foldersIsLoadingStart} />
      )}
      <DocumentTemplatesTable
        templates={filteredTemplates}
        isLoading={isLoadingStart}
      />
    </Box>
  )
}

DocumentTemplates.propTypes = {
  filter: PropTypes.object.isRequired,
}

export default DocumentTemplates
